import tt, { useRef as ft, createElement as X, useReducer as ht, useEffect as mt, useDebugValue as vt, createContext as _t, useContext as bt } from "react";
const k = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1, VITE_COLLAB_CONNECTION_DIAGNOSTICS: "off" };
function et(t) {
  return "init" in t;
}
function V(t) {
  return !!t.write;
}
function Y(t) {
  return "v" in t || "e" in t;
}
function T(t) {
  if ("e" in t)
    throw t.e;
  if ((k ? "production" : void 0) !== "production" && !("v" in t))
    throw new Error("[Bug] atom state is not initialized");
  return t.v;
}
const N = /* @__PURE__ */ new WeakMap();
function nt(t) {
  var e;
  return U(t) && !!((e = N.get(t)) != null && e[0]);
}
function gt(t) {
  const e = N.get(t);
  e?.[0] && (e[0] = !1, e[1].forEach((o) => o()));
}
function x(t, e) {
  let o = N.get(t);
  if (!o) {
    o = [!0, /* @__PURE__ */ new Set()], N.set(t, o);
    const n = () => {
      o[0] = !1;
    };
    t.then(n, n);
  }
  o[1].add(e);
}
function U(t) {
  return typeof t?.then == "function";
}
function ot(t, e, o) {
  if (!o.p.has(t)) {
    o.p.add(t);
    const n = () => o.p.delete(t);
    e.then(n, n);
  }
}
function st(t, e, o) {
  var n;
  const s = /* @__PURE__ */ new Set();
  for (const i of ((n = o.get(t)) == null ? void 0 : n.t) || [])
    s.add(i);
  for (const i of e.p)
    s.add(i);
  return s;
}
const St = (t, e, ...o) => e.read(...o), pt = (t, e, ...o) => e.write(...o), At = (t, e) => {
  var o;
  return (o = e.INTERNAL_onInit) == null ? void 0 : o.call(e, t);
}, wt = (t, e, o) => {
  var n;
  return (n = e.onMount) == null ? void 0 : n.call(e, o);
}, It = (t, e) => {
  var o;
  const n = S(t), s = n[0], i = n[6], r = n[9];
  if ((k ? "production" : void 0) !== "production" && !e)
    throw new Error("Atom is undefined or null");
  let c = s.get(e);
  return c || (c = { d: /* @__PURE__ */ new Map(), p: /* @__PURE__ */ new Set(), n: 0 }, s.set(e, c), (o = i.i) == null || o.call(i, e), r?.(t, e)), c;
}, kt = (t) => {
  const e = S(t), o = e[1], n = e[3], s = e[4], i = e[5], r = e[6], c = e[13], a = [], u = (l) => {
    try {
      l();
    } catch (d) {
      a.push(d);
    }
  };
  do {
    r.f && u(r.f);
    const l = /* @__PURE__ */ new Set(), d = l.add.bind(l);
    n.forEach((h) => {
      var f;
      return (f = o.get(h)) == null ? void 0 : f.l.forEach(d);
    }), n.clear(), i.forEach(d), i.clear(), s.forEach(d), s.clear(), l.forEach(u), n.size && c(t);
  } while (n.size || i.size || s.size);
  if (a.length)
    throw new AggregateError(a);
}, yt = (t) => {
  const e = S(t), o = e[1], n = e[2], s = e[3], i = e[11], r = e[14], c = e[17], a = [], u = /* @__PURE__ */ new WeakSet(), l = /* @__PURE__ */ new WeakSet(), d = Array.from(s);
  for (; d.length; ) {
    const h = d[d.length - 1], f = i(t, h);
    if (l.has(h)) {
      d.pop();
      continue;
    }
    if (u.has(h)) {
      if (n.get(h) === f.n)
        a.push([h, f]);
      else if ((k ? "production" : void 0) !== "production" && n.has(h))
        throw new Error("[Bug] invalidated atom exists");
      l.add(h), d.pop();
      continue;
    }
    u.add(h);
    for (const b of st(h, f, o))
      u.has(b) || d.push(b);
  }
  for (let h = a.length - 1; h >= 0; --h) {
    const [f, b] = a[h];
    let p = !1;
    for (const A of b.d.keys())
      if (A !== f && s.has(A)) {
        p = !0;
        break;
      }
    p && (r(t, f), c(t, f)), n.delete(f);
  }
}, W = /* @__PURE__ */ new WeakSet(), Bt = (t, e) => {
  var o, n;
  const s = S(t), i = s[1], r = s[2], c = s[3], a = s[6], u = s[7], l = s[11], d = s[12], h = s[13], f = s[14], b = s[16], p = s[17], A = s[20], m = l(t, e);
  if (Y(m)) {
    if (i.has(e) && r.get(e) !== m.n)
      return m;
    let _ = !1;
    for (const [R, C] of m.d)
      if (f(t, R).n !== C) {
        _ = !0;
        break;
      }
    if (!_)
      return m;
  }
  m.d.clear();
  let g = !0;
  function I() {
    i.has(e) && (p(t, e), h(t), d(t));
  }
  function P(_) {
    var R;
    if (_ === e) {
      const Q = l(t, _);
      if (!Y(Q))
        if (et(_))
          A(t, _, _.init);
        else
          throw new Error("no atom init");
      return T(Q);
    }
    const C = f(t, _);
    try {
      return T(C);
    } finally {
      m.d.set(_, C.n), nt(m.v) && ot(e, m.v, C), i.has(e) && ((R = i.get(_)) == null || R.t.add(e)), g || I();
    }
  }
  let y, L;
  const K = {
    get signal() {
      return y || (y = new AbortController()), y.signal;
    },
    get setSelf() {
      return (k ? "production" : void 0) !== "production" && console.warn(
        "[DEPRECATED] setSelf is deprecated and will be removed in v3."
      ), (k ? "production" : void 0) !== "production" && !V(e) && console.warn("setSelf function cannot be used with read-only atom"), !L && V(e) && (L = (..._) => {
        if ((k ? "production" : void 0) !== "production" && g && console.warn("setSelf function cannot be called in sync"), !g)
          try {
            return b(t, e, ..._);
          } finally {
            h(t), d(t);
          }
      }), L;
    }
  }, q = m.n;
  try {
    (k ? "production" : void 0) !== "production" && W.delete(t);
    const _ = u(t, e, P, K);
    return (k ? "production" : void 0) !== "production" && W.has(t) && console.warn(
      "Detected store mutation during atom read. This is not supported."
    ), A(t, e, _), U(_) && (x(_, () => y?.abort()), _.then(I, I)), (o = a.r) == null || o.call(a, e), m;
  } catch (_) {
    return delete m.v, m.e = _, ++m.n, m;
  } finally {
    g = !1, q !== m.n && r.get(e) === q && (r.set(e, m.n), c.add(e), (n = a.c) == null || n.call(a, e));
  }
}, Dt = (t, e) => {
  const o = S(t), n = o[1], s = o[2], i = o[11], r = [e];
  for (; r.length; ) {
    const c = r.pop(), a = i(t, c);
    for (const u of st(c, a, n)) {
      const l = i(t, u);
      s.set(u, l.n), r.push(u);
    }
  }
}, Lt = (t, e, ...o) => {
  const n = S(t), s = n[3], i = n[6], r = n[8], c = n[11], a = n[12], u = n[13], l = n[14], d = n[15], h = n[16], f = n[17], b = n[20];
  let p = !0;
  const A = (g) => T(l(t, g)), m = (g, ...I) => {
    var P;
    const y = c(t, g);
    try {
      if (g === e) {
        if (!et(g))
          throw new Error("atom not writable");
        (k ? "production" : void 0) !== "production" && W.add(t);
        const L = y.n, K = I[0];
        b(t, g, K), f(t, g), L !== y.n && (s.add(g), d(t, g), (P = i.c) == null || P.call(i, g));
        return;
      } else
        return h(t, g, ...I);
    } finally {
      p || (u(t), a(t));
    }
  };
  try {
    return r(t, e, A, m, ...o);
  } finally {
    p = !1;
  }
}, Ct = (t, e) => {
  var o;
  const n = S(t), s = n[1], i = n[3], r = n[6], c = n[11], a = n[15], u = n[18], l = n[19], d = c(t, e), h = s.get(e);
  if (h && !nt(d.v)) {
    for (const [f, b] of d.d)
      if (!h.d.has(f)) {
        const p = c(t, f);
        u(t, f).t.add(e), h.d.add(f), b !== p.n && (i.add(f), a(t, f), (o = r.c) == null || o.call(r, f));
      }
    for (const f of h.d)
      if (!d.d.has(f)) {
        h.d.delete(f);
        const b = l(t, f);
        b?.t.delete(e);
      }
  }
}, Ot = (t, e) => {
  var o;
  const n = S(t), s = n[1], i = n[4], r = n[6], c = n[10], a = n[11], u = n[12], l = n[13], d = n[14], h = n[16], f = n[18], b = a(t, e);
  let p = s.get(e);
  if (!p) {
    d(t, e);
    for (const A of b.d.keys())
      f(t, A).t.add(e);
    if (p = {
      l: /* @__PURE__ */ new Set(),
      d: new Set(b.d.keys()),
      t: /* @__PURE__ */ new Set()
    }, s.set(e, p), V(e)) {
      const A = () => {
        let m = !0;
        const g = (...I) => {
          try {
            return h(t, e, ...I);
          } finally {
            m || (l(t), u(t));
          }
        };
        try {
          const I = c(t, e, g);
          I && (p.u = () => {
            m = !0;
            try {
              I();
            } finally {
              m = !1;
            }
          });
        } finally {
          m = !1;
        }
      };
      i.add(A);
    }
    (o = r.m) == null || o.call(r, e);
  }
  return p;
}, Et = (t, e) => {
  var o, n;
  const s = S(t), i = s[1], r = s[5], c = s[6], a = s[11], u = s[19], l = a(t, e);
  let d = i.get(e);
  if (!d || d.l.size)
    return d;
  let h = !1;
  for (const f of d.t)
    if ((o = i.get(f)) != null && o.d.has(e)) {
      h = !0;
      break;
    }
  if (!h) {
    d.u && r.add(d.u), d = void 0, i.delete(e);
    for (const f of l.d.keys()) {
      const b = u(t, f);
      b?.t.delete(e);
    }
    (n = c.u) == null || n.call(c, e);
    return;
  }
  return d;
}, Mt = (t, e, o) => {
  const n = S(t)[11], s = n(t, e), i = "v" in s, r = s.v;
  if (U(o))
    for (const c of s.d.keys())
      ot(
        e,
        o,
        n(t, c)
      );
  s.v = o, delete s.e, (!i || !Object.is(r, s.v)) && (++s.n, U(r) && gt(r));
}, Pt = (t, e) => {
  const o = S(t)[14];
  return T(o(t, e));
}, Rt = (t, e, ...o) => {
  const n = S(t), s = n[12], i = n[13], r = n[16];
  try {
    return r(t, e, ...o);
  } finally {
    i(t), s(t);
  }
}, Tt = (t, e, o) => {
  const n = S(t), s = n[12], i = n[18], r = n[19], a = i(t, e).l;
  return a.add(o), s(t), () => {
    a.delete(o), r(t, e), s(t);
  };
}, ct = /* @__PURE__ */ new WeakMap(), S = (t) => {
  const e = ct.get(t);
  if ((k ? "production" : void 0) !== "production" && !e)
    throw new Error(
      "Store must be created by buildStore to read its building blocks"
    );
  return e;
};
function Nt(...t) {
  const e = {
    get(n) {
      const s = S(e)[21];
      return s(e, n);
    },
    set(n, ...s) {
      const i = S(e)[22];
      return i(e, n, ...s);
    },
    sub(n, s) {
      const i = S(e)[23];
      return i(e, n, s);
    }
  }, o = [
    // store state
    /* @__PURE__ */ new WeakMap(),
    // atomStateMap
    /* @__PURE__ */ new WeakMap(),
    // mountedMap
    /* @__PURE__ */ new WeakMap(),
    // invalidatedAtoms
    /* @__PURE__ */ new Set(),
    // changedAtoms
    /* @__PURE__ */ new Set(),
    // mountCallbacks
    /* @__PURE__ */ new Set(),
    // unmountCallbacks
    {},
    // storeHooks
    // atom interceptors
    St,
    pt,
    At,
    wt,
    // building-block functions
    It,
    kt,
    yt,
    Bt,
    Dt,
    Lt,
    Ct,
    Ot,
    Et,
    Mt,
    Pt,
    Rt,
    Tt,
    void 0
  ].map((n, s) => t[s] || n);
  return ct.set(e, Object.freeze(o)), e;
}
const it = {};
let Ut = 0;
function v(t, e) {
  const o = `atom${++Ut}`, n = {
    toString() {
      return (it ? "production" : void 0) !== "production" && this.debugLabel ? o + ":" + this.debugLabel : o;
    }
  };
  return typeof t == "function" ? n.read = t : (n.init = t, n.read = Kt, n.write = Gt), e && (n.write = e), n;
}
function Kt(t) {
  return t(this);
}
function Gt(t, e, o) {
  return e(
    this,
    typeof o == "function" ? o(t(this)) : o
  );
}
function j() {
  return Nt();
}
let O;
function Vt() {
  return O || (O = j(), (it ? "production" : void 0) !== "production" && (globalThis.__JOTAI_DEFAULT_STORE__ || (globalThis.__JOTAI_DEFAULT_STORE__ = O), globalThis.__JOTAI_DEFAULT_STORE__ !== O && console.warn(
    "Detected multiple Jotai instances. It may cause unexpected behavior with the default store. https://github.com/pmndrs/jotai/discussions/2044"
  ))), O;
}
const F = _t(
  void 0
);
function xt(t) {
  return bt(F) || Vt();
}
function Jt({
  children: t,
  store: e
}) {
  const o = ft(null);
  return e ? X(F.Provider, { value: e }, t) : (o.current === null && (o.current = j()), X(
    F.Provider,
    {
      // TODO: If this is not a false positive, consider using useState instead of useRef like https://github.com/pmndrs/jotai/pull/2771
      // eslint-disable-next-line react-hooks/refs
      value: o.current
    },
    t
  ));
}
const H = (t) => typeof t?.then == "function", z = (t) => {
  t.status || (t.status = "pending", t.then(
    (e) => {
      t.status = "fulfilled", t.value = e;
    },
    (e) => {
      t.status = "rejected", t.reason = e;
    }
  ));
}, Wt = tt.use || // A shim for older React versions
((t) => {
  if (t.status === "pending")
    throw t;
  if (t.status === "fulfilled")
    return t.value;
  throw t.status === "rejected" ? t.reason : (z(t), t);
}), G = /* @__PURE__ */ new WeakMap(), Z = (t, e) => {
  let o = G.get(t);
  return o || (o = new Promise((n, s) => {
    let i = t;
    const r = (u) => (l) => {
      i === u && n(l);
    }, c = (u) => (l) => {
      i === u && s(l);
    }, a = () => {
      try {
        const u = e();
        H(u) ? (G.set(u, o), i = u, u.then(r(u), c(u)), x(u, a)) : n(u);
      } catch (u) {
        s(u);
      }
    };
    t.then(r(t), c(t)), x(t, a);
  }), G.set(t, o)), o;
};
function $t(t, e) {
  const { delay: o, unstable_promiseStatus: n = !tt.use } = {}, s = xt(), [[i, r, c], a] = ht(
    (l) => {
      const d = s.get(t);
      return Object.is(l[0], d) && l[1] === s && l[2] === t ? l : [d, s, t];
    },
    void 0,
    () => [s.get(t), s, t]
  );
  let u = i;
  if ((r !== s || c !== t) && (a(), u = s.get(t)), mt(() => {
    const l = s.sub(t, () => {
      if (n)
        try {
          const d = s.get(t);
          H(d) && z(
            Z(d, () => s.get(t))
          );
        } catch {
        }
      if (typeof o == "number") {
        setTimeout(a, o);
        return;
      }
      a();
    });
    return a(), l;
  }, [s, t, o, n]), vt(u), H(u)) {
    const l = Z(u, () => s.get(t));
    return n && z(l), Wt(l);
  }
  return u;
}
function w(t, e) {
  let o = null;
  const n = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Set();
  function i(c) {
    let a;
    if (a = n.get(c), a !== void 0)
      if (o?.(a[1], c))
        i.remove(c);
      else
        return a[0];
    const u = t(c);
    return n.set(c, [u, Date.now()]), r("CREATE", c, u), u;
  }
  function r(c, a, u) {
    for (const l of s)
      l({ type: c, param: a, atom: u });
  }
  return i.unstable_listen = (c) => (s.add(c), () => {
    s.delete(c);
  }), i.getParams = () => n.keys(), i.remove = (c) => {
    {
      if (!n.has(c))
        return;
      const [a] = n.get(c);
      n.delete(c), r("REMOVE", c, a);
    }
  }, i.setShouldRemove = (c) => {
    if (o = c, !!o)
      for (const [a, [u, l]] of n)
        o(l, a) && (n.delete(a), r("REMOVE", a, u));
  }, i;
}
const qt = j();
w(
  (t) => v(null)
);
const E = {
  light: {
    id: "light",
    name: "Light",
    isDark: !1,
    colors: {
      background: "#ffffff",
      foreground: "#1e1e1e",
      accent: "#007acc",
      border: "#e5e5e5",
      editorBackground: "#ffffff",
      editorForeground: "#1e1e1e",
      syntaxKeyword: "#0000ff",
      syntaxString: "#a31515",
      syntaxComment: "#008000",
      syntaxVariable: "#001080"
    }
  },
  dark: {
    id: "dark",
    name: "Dark",
    isDark: !0,
    colors: {
      background: "#1e1e1e",
      foreground: "#d4d4d4",
      accent: "#0e639c",
      border: "#3c3c3c",
      editorBackground: "#1e1e1e",
      editorForeground: "#d4d4d4",
      syntaxKeyword: "#569cd6",
      syntaxString: "#ce9178",
      syntaxComment: "#6a9955",
      syntaxVariable: "#9cdcfe"
    }
  }
}, rt = v("dark"), at = v((t) => {
  const e = t(rt);
  return E[e] ? E[e] : e.includes("dark") ? E.dark : E.light;
});
v((t) => t(at)?.isDark ?? !0);
v((t) => t(at)?.colors ?? E.dark.colors);
v(null, (t, e, o) => {
  e(rt, o);
});
const J = w((t) => v(!1)), ut = w(
  (t) => v(!1)
), $ = w(
  (t) => v(!1)
), B = w(
  (t) => v([])
), M = w(
  (t) => v(null)
), lt = {
  isPinned: !1,
  isVirtual: !1
}, D = w(
  (t) => v(lt)
);
w(
  (t) => v((e) => e(B(t)).filter((n) => e(J(n))).length)
);
w(
  (t) => v((e) => e(B(t)).some((n) => e($(n))))
);
v(
  null,
  (t, e, {
    context: o,
    key: n,
    isVirtual: s = !1
  }) => {
    const i = t(B(o));
    if (i.includes(n)) {
      if (e(M(o), n), !s) {
        const c = t(D(n));
        c.isVirtual && e(D(n), { ...c, isVirtual: !1 });
      }
      return;
    }
    let r = i;
    if (s) {
      const c = i.find(
        (a) => t(D(a)).isVirtual
      );
      c && (r = i.filter((a) => a !== c), J.remove(c), ut.remove(c), $.remove(c), D.remove(c));
    }
    e(B(o), [...r, n]), e(D(n), { ...lt, isVirtual: s }), e(M(o), n);
  }
);
v(
  null,
  (t, e, { context: o, key: n }) => {
    const s = t(B(o)), i = s.indexOf(n);
    if (i === -1) return;
    const r = s.filter((c) => c !== n);
    if (e(B(o), r), t(M(o)) === n)
      if (r.length > 0) {
        const c = Math.min(i, r.length - 1);
        e(M(o), r[c]);
      } else
        e(M(o), null);
    J.remove(n), ut.remove(n), $.remove(n), D.remove(n);
  }
);
v(
  null,
  (t, e, { context: o, newOrder: n }) => {
    e(B(o), n);
  }
);
const Ft = w((t) => v(!1)), Ht = w(
  (t) => v(null)
);
w((t) => v(0));
const dt = v([]);
v((t) => t(dt).filter((o) => t(Ft(o))).length);
v((t) => t(dt).some((o) => t(Ht(o)) !== null));
const zt = "local";
function Qt(t) {
  return t?.orgId === zt;
}
class Xt extends Error {
  retryable;
  constructor(e, o) {
    super(e), this.name = "CollabScopeResolutionError", this.retryable = o.retryable, o.cause !== void 0 && Object.defineProperty(this, "cause", { value: o.cause, configurable: !0 });
  }
}
function Yt(t) {
  return { newTab: t.metaKey || t.ctrlKey };
}
export {
  Xt as C,
  Jt as P,
  v as a,
  w as b,
  Yt as c,
  Qt as i,
  qt as s,
  $t as u
};
//# sourceMappingURL=index-CgGCtE61.js.map
